<template>
    <div :class="theme.tabs" :data-count="tabsCount">
        <div v-for="tab, link in tabs" :key="link" :class="tabClasses(link)">
            <div v-if="tab.active" :class="theme.tabLabel" v-ripple="rippleColor" @click="handleClick(link)">
                {{ tab.label }}
            </div>
            <div v-else :class="theme.tabLabel">
                {{ tab.label }}
            </div>
        </div>
        <div :class="theme.slide"></div>
    </div>
</template>
<script>
    import { Ripple } from '../../directives';
    import theme from './tabs.scss';

    export default {
        name: 'tabs',
        directives: {
            Ripple,
        },
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            tabs: {
                type: Object,
                default() {
                    return {};
                }
            },
            ripple: {
                type: [String, Boolean],
                default: true,
            },
            selected: String,
        },
        computed: {
            tabsCount() {
                return Object.keys(this.tabs).length;
            },
            rippleColor() {
                return typeof this.ripple === 'string'
                    ? this.ripple
                    : 'rgba(3, 169, 244, .05)';
            }
        },
        methods: {
            tabClasses(tab) {
                return {
                    [theme.tab]: true,
                    [theme.isSelected]: this.selected === tab,
                    [theme.isDisabled]: !this.tabs[tab].active,
                }
            },
            handleClick(link) {
                this.$emit('click', link);
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Tabs.vue?2d9374e0